import React from 'react';
import { Link } from 'react-router-dom';
import "./Footer.css";

const Footer = () => {
  return (
    <div className='footer bg-dark section-p' id="footer">
      <div className='container'>
        <div className='section-title'>
          <h3 className='text-brown'>Create with <span className='text-white'>Us</span></h3>
        </div>
        <div className='footer-content'>
          <br />
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1'>
            <Link to="/terms" className='text-white'>Terms of Service</Link>
          </p>
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1'>
            <Link to="/policy" className='text-white'>Privacy Policy</Link>
          </p>
          <br />
          <p className='text-center fs-14 text-white op-07 fw-3 ls-1 reserved-text'>2201 MENAUL BLVD NE STE A Albuquerque NM 87107 USA. All Rights Reserved &copy; 2023</p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
